import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  faultMessages: null,
}

const getters = {
  faultMessages(faultMessagesParams) {
    const url = `/Dplf/MessageCodesByDate/${faultMessagesParams.tail}?&start=${faultMessagesParams.startDate}&end=${faultMessagesParams.endDate}`
    return axios.get(url)
  },
}

export default class FaultMessagesService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }
}
